import { useState, useEffect } from "react";

import { getScreenType } from "./../helpers/common";

export enum IScreenByType {
    MOBILE = "MOBILE",
    DESKTOP_SMALL = "DESKTOP_SMALL",
    DESKTOP_MIDDLE = "DESKTOP_MIDDLE",
    DESKTOP = "DESKTOP",
    DESKTOP_BIG = "DESKTOP_BIG",
}
interface MediaEvent {
    (): void;
}

type UseDisclosure = () => {
    type: IScreenByType;
};

export const useMedia: UseDisclosure = () => {
    const [type, setType] = useState<IScreenByType>(IScreenByType.DESKTOP_SMALL);

    const event: MediaEvent = () => {
        setType(getScreenType());
    };

    useEffect(() => {
        event();
        window.addEventListener("resize", event);
        return () => window.removeEventListener("resize", event);
    }, []);

    return { type };
};
